import { render, staticRenderFns } from "./DescriptionFlat.vue?vue&type=template&id=f5c57e7c"
import script from "./DescriptionFlat.vue?vue&type=script&lang=js"
export * from "./DescriptionFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports